module.exports = __webpack_public_path__ + "img/banner8.132044ee.png";